import { render } from "./EvaluationDetailsTable.vue?vue&type=template&id=a16882a0&scoped=true"
import script from "./EvaluationDetailsTable.vue?vue&type=script&lang=js"
export * from "./EvaluationDetailsTable.vue?vue&type=script&lang=js"

import "./EvaluationDetailsTable.vue?vue&type=style&index=0&id=a16882a0&scoped=true&lang=css"

import exportComponent from "../../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a16882a0"]])

export default __exports__